import { IYxInputPropTypes, lableIValueItme } from "./basePropType";
import PropTypes from "prop-types";
import { IYxrequest } from "../../../utils/propType";

export const ISelectPropTypes = {
  ...IYxInputPropTypes,

  //用于循环显示下拉列表，必须包含value和labels
  data: PropTypes.arrayOf(lableIValueItme),

  //接口请求参数
  requestParam: IYxrequest,

  //版本号，不一致时重新请求
  version: PropTypes.string,

  //是否允许在onSearch的时候自动刷新请求，并会把同id赋给请求参数，只有存在远程请求时可用
  isSearchRefresh: PropTypes.bool,

  //设置为true的时候，会将请求的第一个值作为默认值
  requestDefaultValue: PropTypes.bool,
};

export const selectDefaultProps = () => ({
  children: "", //子节点
  data: null, //用于循环显示下拉列表，必须包含key和label
  rules: {
    max: "",
  },
  inputParam: {},
  styleParam: {
    width: "sm", //宽度  xxs,xs,sm,md,lg,xl
    size: "default", //大小
    type: "default", //类型
  },
  isBool: "false", //开启默认在option加入true,false,默认defaultValue设置为true,  defaultValue> requestDefaultValue>isBool
  version: "", //版本号
  isSearchRefresh: false, //是否在onChange的时候重新请求数据，只有存在远程数据请求时才生效
});



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/IpropType/selectPropType.js